export default "__VITE_ASSET__rJVTr40U__"